enum FileReaderReadyStateEnum {
	empty = 0,
	loading = 1,
	done = 2
}
export default FileReaderReadyStateEnum;
